/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Rating_UnsureInputs */

const en_us2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort of`)
};

const pt_br2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais ou menos`)
};

const es_419_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más o menos`)
};

const pt_pt2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais ou menos`)
};

const fr_fr2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyennement`)
};

const de_de2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht so`)
};

const it_it2_engagement_rating_unsure = /** @type {(inputs: Engagement_Rating_UnsureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Così così`)
};

/**
* | output |
* | --- |
* | "Sort of" |
*
* @param {Engagement_Rating_UnsureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_rating_unsure = /** @type {((inputs?: Engagement_Rating_UnsureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Rating_UnsureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_rating_unsure(inputs)
	if (locale === "es-419") return es_419_engagement_rating_unsure(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_rating_unsure(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_rating_unsure(inputs)
	if (locale === "de-DE") return de_de2_engagement_rating_unsure(inputs)
	if (locale === "it-IT") return it_it2_engagement_rating_unsure(inputs)
	return en_us2_engagement_rating_unsure(inputs)
});
export { engagement_rating_unsure as "engagement.rating_unsure" }